// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-list-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.member-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.member-list-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

/* Member Type Tabs */
.member-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 25px;
  border-bottom: 2px solid #dee2e6;
}

.member-tab {
  padding: 12px 24px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: all 0.2s ease;
}

.member-tab:hover {
  color: #007bff;
  background-color: #f8f9fa;
}

.member-tab.active {
  color: #007bff;
  font-weight: 600;
}

.member-tab.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #007bff;
  border-radius: 2px 2px 0 0;
}

.member-tab i {
  font-size: 14px;
}

.member-list-filters {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}

.filter-group {
  flex: 1 1;
  min-width: 200px;
  position: relative;
}

.filter-group .form-control {
  width: 100%;
}

.autocomplete-wrapper {
  position: relative;
  width: 100%;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
}

.autocomplete-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s ease;
}

.autocomplete-item:hover {
  background-color: #f5f5f5;
  color: #333;
}

.autocomplete-item:last-child {
  border-bottom: none;
}

/* Tailwind-style Combobox */
.combobox-wrapper {
  position: relative;
  width: 100%;
}

.combobox-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  max-height: 280px;
  overflow-y: auto;
  z-index: 1000;
}

.combobox-item {
  padding: 10px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.15s ease;
  color: #374151;
  font-size: 14px;
}

.combobox-item:hover {
  background-color: #f3f4f6;
}

.combobox-item.active {
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 500;
}

.combobox-item i {
  color: #2563eb;
  font-size: 12px;
}

.combobox-item .text-gray-500 {
  color: #6b7280;
  font-style: italic;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-container p {
  margin-top: 15px;
  color: #666;
  font-size: 16px;
}

.table-responsive {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow-x: auto;
}

.table {
  margin-bottom: 0;
  width: 100%;
}

.table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  padding: 15px;
  white-space: nowrap;
}

.table tbody td {
  padding: 12px 15px;
  vertical-align: middle;
}

.table tbody td.member-groups-cell {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  max-width: 180px;
  white-space: normal;
  word-break: break-word;
  color: #1f2937;
}

.table tbody td.member-org-cell {
  font-size: 13px;
  color: #374151;
  max-width: 140px;
  white-space: normal;
  word-break: break-word;
}

.table tbody td.member-nickname-cell {
  font-weight: 500;
  color: #111827;
}

.table tbody td.member-role-cell {
  font-size: 13px;
  white-space: nowrap;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.member-list-nickname {
  color: #6b7280;
  font-weight: 400;
  font-size: 12px;
}

.member-email-cell {
  font-size: 11px;
  color: #9ca3af;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-name-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.member-name-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

.badge {
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.actions-cell {
  white-space: nowrap;
  min-width: 250px;
}

.actions-cell .btn {
  margin-right: 5px;
  padding: 5px 12px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.actions-cell .btn i {
  font-size: 12px;
}

.actions-cell .btn:last-child {
  margin-right: 0;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.pagination-info {
  color: #666;
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.page-info {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
}

.btn-info {
  background-color: #eef2ff;
  color: #4f46e5;
}

.btn-info:hover {
  background-color: #e0e7ff;
  color: #3730a3;
}

.btn-warning {
  background-color: #eff6ff;
  color: #2563eb;
}

.btn-warning:hover {
  background-color: #dbeafe;
  color: #1e3a8a;
}

.btn-danger {
  background-color: #fef2f2;
  color: #dc2626;
}

.btn-danger:hover {
  background-color: #fee2e2;
  color: #991b1b;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-link {
  background: none;
  color: #007bff;
  text-decoration: underline;
  padding: 0;
  margin-left: 10px;
}

.btn-link:hover {
  color: #0056b3;
}

.alert {
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Responsive */
@media (max-width: 768px) {
  .member-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .member-list-filters {
    flex-direction: column;
  }

  .filter-group {
    width: 100%;
  }

  .pagination-container {
    flex-direction: column;
    gap: 15px;
  }

  .table-responsive {
    font-size: 14px;
  }

  .table thead th,
  .table tbody td {
    padding: 10px;
  }
}

/* Delete Confirmation Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background-color: #f8f9fa;
  color: #333;
}

.modal-body {
  padding: 24px;
}

.modal-body .alert {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-body .alert-danger {
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c00;
}

.modal-body .alert i {
  font-size: 20px;
}

.modal-body p {
  margin-bottom: 12px;
  line-height: 1.6;
}

.modal-body .text-muted {
  color: #6c757d;
  font-size: 14px;
}

.modal-body .form-group {
  margin-top: 16px;
  margin-bottom: 16px;
}

.modal-body .form-control {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #ced4da;
  border-radius: 6px;
  font-size: 15px;
  transition: border-color 0.2s ease;
}

.modal-body .form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.modal-body .text-danger {
  color: #dc3545;
  margin-top: 8px;
  margin-bottom: 0;
}

.modal-body .text-danger i {
  margin-right: 6px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

.modal-footer .btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.modal-footer .btn-secondary {
  background-color: #6c757d;
  color: white;
}

.modal-footer .btn-secondary:hover {
  background-color: #5a6268;
}

.modal-footer .btn-danger {
  background-color: #dc3545;
  color: white;
}

.modal-footer .btn-danger:hover {
  background-color: #c82333;
}

.modal-footer .btn-danger:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/components/Members/MemberList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mFAAmF;EACnF,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".member-list-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.member-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.member-list-header h2 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Member Type Tabs */\n.member-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 25px;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.member-tab {\n  padding: 12px 24px;\n  border: none;\n  background: transparent;\n  color: #666;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.member-tab:hover {\n  color: #007bff;\n  background-color: #f8f9fa;\n}\n\n.member-tab.active {\n  color: #007bff;\n  font-weight: 600;\n}\n\n.member-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background-color: #007bff;\n  border-radius: 2px 2px 0 0;\n}\n\n.member-tab i {\n  font-size: 14px;\n}\n\n.member-list-filters {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 25px;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  flex: 1;\n  min-width: 200px;\n  position: relative;\n}\n\n.filter-group .form-control {\n  width: 100%;\n}\n\n.autocomplete-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.autocomplete-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-height: 250px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.autocomplete-item {\n  padding: 10px 15px;\n  cursor: pointer;\n  border-bottom: 1px solid #f0f0f0;\n  transition: background-color 0.15s ease;\n}\n\n.autocomplete-item:hover {\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n.autocomplete-item:last-child {\n  border-bottom: none;\n}\n\n/* Tailwind-style Combobox */\n.combobox-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.combobox-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  max-height: 280px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.combobox-item {\n  padding: 10px 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: all 0.15s ease;\n  color: #374151;\n  font-size: 14px;\n}\n\n.combobox-item:hover {\n  background-color: #f3f4f6;\n}\n\n.combobox-item.active {\n  background-color: #eff6ff;\n  color: #2563eb;\n  font-weight: 500;\n}\n\n.combobox-item i {\n  color: #2563eb;\n  font-size: 12px;\n}\n\n.combobox-item .text-gray-500 {\n  color: #6b7280;\n  font-style: italic;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.loading-container p {\n  margin-top: 15px;\n  color: #666;\n  font-size: 16px;\n}\n\n.table-responsive {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow-x: auto;\n}\n\n.table {\n  margin-bottom: 0;\n  width: 100%;\n}\n\n.table thead th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n  padding: 15px;\n  white-space: nowrap;\n}\n\n.table tbody td {\n  padding: 12px 15px;\n  vertical-align: middle;\n}\n\n.table tbody td.member-groups-cell {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.35;\n  max-width: 180px;\n  white-space: normal;\n  word-break: break-word;\n  color: #1f2937;\n}\n\n.table tbody td.member-org-cell {\n  font-size: 13px;\n  color: #374151;\n  max-width: 140px;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.table tbody td.member-nickname-cell {\n  font-weight: 500;\n  color: #111827;\n}\n\n.table tbody td.member-role-cell {\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.member-list-nickname {\n  color: #6b7280;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.member-email-cell {\n  font-size: 11px;\n  color: #9ca3af;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.member-name-link {\n  color: #007bff;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.member-name-link:hover {\n  text-decoration: underline;\n  color: #0056b3;\n}\n\n.badge {\n  padding: 5px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.actions-cell {\n  white-space: nowrap;\n  min-width: 250px;\n}\n\n.actions-cell .btn {\n  margin-right: 5px;\n  padding: 5px 12px;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.actions-cell .btn i {\n  font-size: 12px;\n}\n\n.actions-cell .btn:last-child {\n  margin-right: 0;\n}\n\n.pagination-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  padding: 15px 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.pagination-info {\n  color: #666;\n  font-size: 14px;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.page-info {\n  color: #666;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.btn {\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.btn-info {\n  background-color: #eef2ff;\n  color: #4f46e5;\n}\n\n.btn-info:hover {\n  background-color: #e0e7ff;\n  color: #3730a3;\n}\n\n.btn-warning {\n  background-color: #eff6ff;\n  color: #2563eb;\n}\n\n.btn-warning:hover {\n  background-color: #dbeafe;\n  color: #1e3a8a;\n}\n\n.btn-danger {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n\n.btn-danger:hover {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-link {\n  background: none;\n  color: #007bff;\n  text-decoration: underline;\n  padding: 0;\n  margin-left: 10px;\n}\n\n.btn-link:hover {\n  color: #0056b3;\n}\n\n.alert {\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .member-list-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .member-list-filters {\n    flex-direction: column;\n  }\n\n  .filter-group {\n    width: 100%;\n  }\n\n  .pagination-container {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .table-responsive {\n    font-size: 14px;\n  }\n\n  .table thead th,\n  .table tbody td {\n    padding: 10px;\n  }\n}\n\n/* Delete Confirmation Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  background-color: #f8f9fa;\n  color: #333;\n}\n\n.modal-body {\n  padding: 24px;\n}\n\n.modal-body .alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.modal-body .alert-danger {\n  background-color: #fee;\n  border: 1px solid #fcc;\n  color: #c00;\n}\n\n.modal-body .alert i {\n  font-size: 20px;\n}\n\n.modal-body p {\n  margin-bottom: 12px;\n  line-height: 1.6;\n}\n\n.modal-body .text-muted {\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.modal-body .form-group {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.modal-body .form-control {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #ced4da;\n  border-radius: 6px;\n  font-size: 15px;\n  transition: border-color 0.2s ease;\n}\n\n.modal-body .form-control:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.modal-body .text-danger {\n  color: #dc3545;\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n.modal-body .text-danger i {\n  margin-right: 6px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #dee2e6;\n  background-color: #f8f9fa;\n  border-radius: 0 0 8px 8px;\n}\n\n.modal-footer .btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.modal-footer .btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.modal-footer .btn-secondary:hover {\n  background-color: #5a6268;\n}\n\n.modal-footer .btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.modal-footer .btn-danger:hover {\n  background-color: #c82333;\n}\n\n.modal-footer .btn-danger:disabled {\n  background-color: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
